import { combineReducers } from 'redux';

import {
  getUserFail,
  getUserRequest,
  getUserSuccess,
  saveUserFail,
  saveUserRequest,
  saveUserSuccess,
  clearUserState, initUserSuccess, initUserRequest, initUserFail,
} from '../actions';
import { UserAction } from '../types';
import { User } from '../../../../types/items';
import { Loadable, Reducer } from '../../../types';

type State = Loadable<User>;
type ReducerOf<T extends keyof State> = Reducer<State, UserAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case initUserRequest.type:
    case getUserRequest.type:
    case clearUserState.type:
      return null;

    case saveUserSuccess.type:
    case getUserSuccess.type:
    case initUserSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getUserRequest.type:
    case saveUserRequest.type:
    case initUserRequest.type:
      return true;

    case getUserSuccess.type:
    case getUserFail.type:
    case saveUserSuccess.type:
    case saveUserFail.type:
    case initUserSuccess.type:
    case initUserFail.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<State>({
  data,
  loading,
});
